import {useEffect, useState} from "react";
import {lookupClientSecret} from "./common/api/CartApi";
import {CreditCard, PaymentForm} from "react-square-web-payments-sdk";
import {squarePay, squareSave} from "./common/api/SquareApi";

export default function SquareCheckoutPage({client, cart, guestName, handleSuccess, handleError, storeCard, cartCheckIn}) {

  const [stripePromise, setStripePromise] = useState(null);
  const [applicationId, setApplicationId] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [clientCart, setClientCart] = useState(cart);

  useEffect(() => {
    lookupClientSecret(client).then((result) => {
      setApplicationId(result['applicationId'])
      setLocationId(result['locationId'])
    });
  }, []);

  const [processing, setProcessing] = useState(false);

  const squarePayFn = async (payment) => {

    let _cart = {...clientCart}
    _cart.cardNonce = payment.sourceId;
    _cart.guestName = guestName;
    _cart.cartCheckIn = cartCheckIn;

    if (storeCard) {
      squareSave(client, _cart).then((resp) => {
        handleSuccess(resp.data);
      }).catch(function (error) {
        return handleError(error);
      });
    } else {
      squarePay(client, _cart).then((resp) => {
        handleSuccess(resp.data);
      }).catch(function (error) {
        return handleError(error);
      });
    }
  }

  const [cardToken, setCardToken] = useState(null);

  return (
    <div>

      {applicationId && <>
        <PaymentForm
          applicationId={applicationId}
          cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
            let payment = {sourceId: token.token}
            squarePayFn(payment).then((resp) => {
              setProcessing(true);
            }).catch((err)=>{
              setProcessing(false);
            });
          }}

          locationId={locationId || "XXXXXXXXXX"}
        >
          <div className={'mt-4'}>
            {processing && <p>Processing...</p>}

            <CreditCard
              disabled={processing}
              buttonProps={{
                onClick: () => {
                  setProcessing(true)
                },
                css: {
                  backgroundColor: processing ? "#ccc" : "#771520",
                  fontSize: "14px",
                  marginTop: '1px',
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#530f16",
                  },
                },
              }}
              // render={(Button) => <center><MDButton color="primary">{storeCard ? 'Save' : 'Pay'}</MDButton></center>}
            >{storeCard ? 'Save' : processing ? 'Processing...' : 'Pay'}</CreditCard>
          </div>
        </PaymentForm>

        {processing && <div style={{
          textAlign:'center',
          height:'144px',
          width:'100%',
          position:'absolute',
          bottom:'0',
          background:'rgba(255,255,255,0)',
          zIndex:'999'
        }}></div>}
      </>
      }
    </div>
  );
}